(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cp-accordion-contents"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const tabContents = document.querySelectorAll('.cp-accordion-contents__item');
    const tabMenus = document.querySelectorAll('.cp-accordion-contents__menu');

    tabMenus.forEach(menu => {
      menu.addEventListener('click', function() {
        const tabId = this.getAttribute('data-tab-id');
        tabMenus.forEach(menu => menu.classList.remove('cp-accordion-contents__menu--active'));
        this.classList.add('cp-accordion-contents__menu--active');

        tabContents.forEach(content => content.classList.remove('cp-accordion-contents__item--active'));
        document.querySelector(`.cp-accordion-contents__item[data-tab-id="${tabId}"]`).classList.add('cp-accordion-contents__item--active');
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cp-tab-contents"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const tabContents = document.querySelectorAll('.cp-tab-contents__item');
    const tabMenus = document.querySelectorAll('.cp-tab-contents__menu');

    tabMenus.forEach(menu => {
      menu.addEventListener('click', function() {
        const tabId = this.getAttribute('data-tab-id');
        tabMenus.forEach(menu => menu.classList.remove('cp-tab-contents__menu--active'));
        this.classList.add('cp-tab-contents__menu--active');

        tabContents.forEach(content => content.classList.remove('cp-tab-contents__item--active'));
        document.querySelector(`.cp-tab-contents__item[data-tab-id="${tabId}"]`).classList.add('cp-tab-contents__item--active');
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ecoflow-wave-3"] && !Shopify.designMode) return;
  try {
    


  window.addEventListener("scroll",()=>{
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      let offsetTop = document.querySelector('#searchBar').offsetTop;
      if (scrollTop > offsetTop) {
           document.querySelector('#searchBar').style.position="fixed";
           document.querySelector('#searchBar').style.top="0";
      } else {
           document.querySelector('#searchBar').style.position="";
           document.querySelector('#searchBar').style.top="";
      }
  })

  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-video"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function() {
        (function() {
            // Only initialize if we have video containers with posters
            if (!document.querySelector('.video-container__poster')) {
                return;
            }

            // Store players in a map using container ID as key
            const players = new Map();

            document.querySelectorAll('.video-container__poster').forEach(poster => {
            poster.addEventListener('click', function(e) {
                const container = poster.closest('.video-container__wrapper');
                const videoElement = container.querySelector('[data-video-id]');
                const ytID = videoElement.getAttribute('data-video-id');
                const embed = container.querySelector('.video-container__embed');
                const containerId = container.getAttribute('id');

                playVideo(embed, ytID, containerId, poster);
                poster.style.display = 'none';
                embed.style.display = 'block';

            });
            });

            // Load YouTube IFrame API (only once)
            if (!window.YT) {
                var tag = document.createElement('script');
                tag.src = "https://www.youtube.com/iframe_api";
                var firstScriptTag = document.getElementsByTagName('script')[0];
                firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
            }

            function playVideo(embed, ytID, containerId, poster) {
                if (!embed) {
                    return;
                }

                // First clear any existing content
                embed.innerHTML = '';

                // Create a new container for the video
                const videoContainer = document.createElement('div');
                videoContainer.className = 'video-container__embed-video';
                embed.appendChild(videoContainer);

                const player = new YT.Player(videoContainer, {
                    videoId: ytID,
                    playerVars: {
                    'playsinline': 1
                    },
                    events: {
                    'onReady': onPlayerReady,
                    'onStateChange': (event) => onPlayerStateChange(event, embed, poster)
                    }
                });

                // Store player reference
                players.set(containerId, player);
            }

            function onPlayerReady(event) {
                event.target.playVideo();
            }

            function onPlayerStateChange(event, embed, poster) {
                // YT.PlayerState.ENDED = 0
                if (event.data === 0) {
                    // Video ended - show poster and hide embed
                    poster.style.display = 'block';
                    embed.style.display = 'none';
                    // Rewind video to beginning
                    event.target.seekTo(0);
                }
            }

            // Clean up players when section is unloaded
            document.addEventListener('shopify:section:unload', function(event) {
                const container = event.target;
                const containerId = container.getAttribute('id');

                if (players.has(containerId)) {
                    const player = players.get(containerId);
                    player.destroy();
                    players.delete(containerId);
                }
            });
        })();
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["series-collection"]) return;
  try {
    
    const swiper = new Swiper('.swiper', {
        autoplay: {
            delay: 2000,
            disableOnInteraction: false,
        },
            pagination: {
            el: '.swiper-pagination',
        },
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    function initializeTestimonialSwiper() {
      var swiperContainer = document.querySelector('.testimonial-slider__block-container--swiper');
      var blockWrapperCount = document.querySelectorAll('.testimonial-slider__block-wrapper').length;

      if (swiperContainer.classList.contains('swiper-initialized')) {
        var existingSwiper = swiperContainer.swiper;
        if (existingSwiper) {
          existingSwiper.destroy();
        }
        swiperContainer.classList.remove('swiper-initialized');
      }

        var swiper = new Swiper(swiperContainer, {
          freeMode: true,
          spaceBetween: 20,
          slidesPerView: 1.19,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          breakpoints: {
            600: {
              slidesPerView: 2.19,
            },
            768: {
              slidesPerView: 3,
              spaceBetween: 27,
            },
          },
        });

        swiperContainer.swiper = swiper;
        swiperContainer.classList.add('swiper-initialized');

    }

    initializeTestimonialSwiper();

    window.addEventListener('resize', function () {
      initializeTestimonialSwiper();
    });
  });

  } catch(e) { console.error(e); }
})();
})();
